<template>
  <div>
    <section id="heading" class="py-12">
      <!-- Header Nav -->
      <header-nav></header-nav>

      <div class="max-w-md mx-auto px-6">
        <!-- Header -->
        <search-form class="mt-16" v-model="searchForm" @submit="search"></search-form>

        <!-- IS DOCTOR MEMBER OF OSTEOPATHIE.BE -->
        <div v-if="searchForm.type === 'OSTEOPATH'" class="text-white">
          <b-checkbox
            v-model="isDoctorMemberOfOsteopathie"
          >
            {{ $t('Member_of_Osteopathie')}}
          </b-checkbox>
        </div>
      </div>
    </section>
    <section class="py-12">
      <div class="max-w-sm mx-auto text-left mb-6">
        <router-link
          to="/"
          class="text-grey hover:text-black p-2"
          v-if="userId && (hasAppointments || hasInvitations || hasEmergencies)"
        >
          <span class="icon">
            <i class="mdi mdi-arrow-left"></i>
          </span>
          {{ $t('Your_appointments') }}
        </router-link>
      </div>

      <patient-loading v-if="loadingTimeslots"></patient-loading>
      <div class="max-w-sm mx-auto px-6" v-else>
        <div v-if="sortedMixAvailabilities.length == 0">
          <div v-if="! (patientPosition || searchForm.place)">
            <bubble>{{ $t('Please_give_your_location_to_look_for_doctors_in_your_region') }}</bubble>
          </div>
          <div v-else-if="!searchForm.type">
            <bubble>{{ $t('Please_select_a_medical_practice') }}</bubble>
          </div>
        </div>
        <div v-else class="mb-12">
          <div
            class="uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6"
          >{{ $t('Available_X', { type: pluralType }) }}</div>

          <template v-for="(item, key) in sortedMixAvailabilities">
            <component :key="key" :is="item.component" :item="item"></component>

            <template v-if="[1, 3, 5].includes(key) && sortedMixAvailabilities.length > key">
              <dfp-slot
                path="/21865209613/Patients/PatientsSearchResults"
                :size="[300, 250]"
                :id="`div-gpt-ad-1575389215612-${key}`"
                class="mb-6"
              />
            </template>
          </template>
        </div>
        <div v-if="sortedMixOffices.length > 0">
          <div
            class="uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6"
          >{{ $t('X_near_Y', {location: patientPlaceName ? patientPlaceName : patientPlace, type: pluralType}) }}</div>

          <component
            v-for="(item, key) in sortedMixOffices"
            :key="key"
            :is="item.component"
            :office="item"
          ></component>
        </div>
        <div
          v-if="! loadingTimeslots && (patientPosition || searchForm.place) && searchForm.type && sortedMixAvailabilities.length == 0 && sortedMixOffices.length == 0"
        >
          <p
            class="text-center mb-10 text-grey-darker leading-normal"
          >{{ $t('No_x_is_currently_available_in_Y', { type: $t('type_' + searchForm.type).toLowerCase(), location: patientPlaceName ? patientPlaceName : patientPlace }) }}</p>
        </div>
        <div v-if="!loadingTimeslots && (patientPosition || searchForm.place) && searchForm.type">
          <bubble>
            <p>{{ $t('You_did_not_find_an_appointment_Activate_the_alert_and_I_will_inform_you_') }}</p>
            <p
              class="mt-2"
              v-if="hasEmergencies && !loadingEmergencies"
            >{{ $t('You_are_already_in_the_waiting_list') }}</p>
          </bubble>
          <waiting-list-button v-if="!hasEmergencies && !loadingEmergencies"></waiting-list-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import firebase from "firebase/app";
import helpers from "@/mixins/helpers";
import moment from "moment";

import Bubble from "@/components/Patient/Bubble";
import HeaderNav from "@/components/Patient/HeaderNav";
import SearchForm from "@/components/Patient/SearchForm";
import OfficeListItem from "@/components/Patient/OfficeListItem";
import PartnerTimeslotListItem from "@/components/Patient/PartnerTimeslotListItem";
import PartnerOfficeListItem from "@/components/Patient/PartnerOfficeListItem";
import TimeslotGroupListItem from "@/components/Patient/TimeslotGroupListItem";
import WaitingListButton from "@/components/Patient/WaitingListButton";

import appointmentRepository from "@/data/AppointmentRepository";
import appointmentInvitationRepository from "@/data/AppointmentInvitationRepository";
import emergencyRepository from "@/data/EmergencyRepository";
import officeRepository from "@/data/OfficeRepository";
import timeSlotRepository from "@/data/TimeSlotRepository";

export default {
  name: "Search",

  mixins: [helpers],

  components: {
    Bubble,
    HeaderNav,
    SearchForm,
    OfficeListItem,
    PartnerOfficeListItem,
    PartnerTimeslotListItem,
    TimeslotGroupListItem,
    WaitingListButton
  },

  data() {
    return {
      loadingTimeslots: false,
      timeslots: [],
      groups: [],
      loadingNearbyOffices: false,
      nearbyOffices: [],
      nearbyPartnerOffices: [],
      loadingAppointments: false,
      hasAppointments: false,
      loadingInvitations: false,
      hasInvitations: false,
      loadingEmergencies: false,
      hasEmergencies: false,
      partners: [],
      searchForm: {
        type: null,
        place: null
      },
      isDoctorMemberOfOsteopathie: false
    };
  },

  computed: {
    shortCode() {
      return this.patientLanguage.shortCode ? this.patientLanguage.shortCode : 'en'
    },
    pluralType() {
      return this.$t(`type_${this.searchForm.type}_plural`);
    },
    sortedMixAvailabilities() {
      let groups = this.groups.map(g => {
        const firstTimeSlot = g.timeslots[0]
        const foundOffice = this.nearbyOffices.find(office => office.id === g.officeId)
        return { ...g, component: "TimeslotGroupListItem", foundOffice };
      });
      let partners = this.partners.map(p => {
        return { ...p, component: "PartnerTimeslotListItem" };
      });


      let mix = [...groups, ...partners].filter(doctor => {
        if (this.isDoctorMemberOfOsteopathie) {
          return doctor.foundOffice && doctor.foundOffice.isDoctorMemberOfOsteopathie
        }
        return doctor;
      });

      return _.sortBy(
        mix.filter(i => i.distance <= 30),
        ["distance"]
      );
    },
    sortedMixOffices() {
      let officeIds = this.groups.map(g => g.officeId);
      let nearbyOffices = this.nearbyOffices
        .map(g => {
          return { ...g, component: "OfficeListItem" };
        })
        .filter(g => officeIds.indexOf(g.id) < 0); // Filter offices that are already represented in the availabilities

      let nearbyPartnerOffices = this.nearbyPartnerOffices.map(p => {
        return { ...p, component: "PartnerOfficeListItem" };
      });

      let mix = [...nearbyOffices, ...nearbyPartnerOffices].filter(office => {
        if (this.isDoctorMemberOfOsteopathie) {
          return office.isDoctorMemberOfOsteopathie;
        } else {
          return office;
        }
      });

      return _.take(
        _.sortBy(
          mix.filter(i => i.distance <= 30),
          ["distance"]
        ),
        20
      );
    }
  },

  async mounted() {
    if (this.patientPosition) {
      this.search();
    }

    if (this.userId) {
      this.fetchPatientResources();
    }

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.fetchPatientResources();
      }
    });

    if (this.$route.query.memberosteo === "true") {
      this.isDoctorMemberOfOsteopathie = true;
    }
  },

  methods: {
    search() {
      this.fetchTimeslots();
      this.fetchPartnerTimeslots();
      this.fetchPartnerOffices();
    },

    async fetchNearbyOffices() {
      if (!this.patientPosition) {
        return false;
      }

      this.loadingNearbyOffices = true;

      officeRepository.allNearby(
        this.patientPosition,
        this.searchForm.type,
        offices => {
          this.nearbyOffices = Object.keys(offices).map(key => offices[key]);
        },
        error => {
          console.log("error", error);
          this.alertPatientError(error.message);

          this.loadingNearbyOffices = false;
        }
      );
    },

    fetchTimeslots() {
      if (!this.patientPosition || !this.searchForm.type) {
        return false;
      }

      this.loadingTimeslots = true;

      timeSlotRepository.allForPatient(
        this.searchForm.type,
        timeSlots => {
          this.timeslots = _.map(timeSlots, timeslot => {
            return _.extend({}, timeslot, {
              distance: 0.1 * window.distanceBetween(
                timeslot.officeLocation._lat || timeslot.officeLocation._latitude,
                timeslot.officeLocation._long || timeslot.officeLocation._longitude,
                this.patientPosition._lat,
                this.patientPosition._long
              )
            });
          });

          this.refreshGroups();
        },
        error => {
          this.alertPatientError(error.message);

          this.loadingTimeslots = false;
        }
      );
    },

    fetchPartnerTimeslots() {
      if (!this.patientPosition || !this.searchForm.type) {
        return false;
      }

      this.partners = [];

      axios
        .get(process.env.CLOUD_FUNCTIONS_BASE_URI + "/getPartnerTimeSlots", {
          params: {
            userId: this.userId ? this.userId : "XXXXXXXXXXXXXXXXXXXXXXXXXXXX",
            medicalPractice: this.searchForm.type,
            language: this.shortCode,
            latitude: this.patientPosition._lat,
            longitude: this.patientPosition._long
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          let partners = [];

          for (let i = 0; i < response.data.length; i++) {
            let timeslot = response.data[i];
            let index = _.findIndex(partners, { doctorId: timeslot.doctorId });

            if (index >= 0) {
              let partner = partners[index];

              if (partner.dateTime >= timeslot.dateTime) {
                partner.dateTime = timeslot.dateTime;
              }

              partner.timeslots.push(timeslot);

              this.$set(partners, index, partner);
            } else {
              partners.push({
                dateTime: timeslot.dateTime,
                doctorAvatar: timeslot.doctorAvatar,
                doctorFirstName: timeslot.doctorFirstName,
                doctorId: timeslot.doctorId,
                doctorLastName: timeslot.doctorLastName,
                isDoctorRegulated: timeslot.isDoctorRegulated,
                medicalPractice: timeslot.medicalPractice,
                officeCountry: timeslot.officeCountry,
                officeLatitude: timeslot.officeLatitude,
                officeLocality: timeslot.officeLocality,
                officeLongitude: timeslot.officeLongitude,
                officeName: timeslot.officeName,
                officeStreetName: timeslot.officeStreetName,
                officeZipCode: timeslot.officeZipCode,
                partnerName: timeslot.partnerName,
                partnerUrl: timeslot.partnerUrl,
                distance: window.distanceBetween(
                  timeslot.officeLatitude,
                  timeslot.officeLongitude,
                  this.patientPosition._lat,
                  this.patientPosition._long
                ),
                timeslots: [timeslot]
              });
            }
          }

          this.partners = partners;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    fetchPartnerOffices() {
      if (!this.patientPosition || !this.searchForm.type) {
        return false;
      }

      this.nearbyPartnerOffices = [];

      axios
        .get(process.env.CLOUD_FUNCTIONS_BASE_URI + "/getPartnerOffices", {
          params: {
            userId: this.userId ? this.userId : "XXXXXXXXXXXXXXXXXXXXXXXXXXXX",
            medicalPractice: this.searchForm.type,
            language: this.shortCode,
            latitude: this.patientPosition._lat,
            longitude: this.patientPosition._long
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          this.nearbyPartnerOffices = response.data.map(office => {
            office["distance"] = window.distanceBetween(
              office.officeLatitude,
              office.officeLongitude,
              this.patientPosition._lat,
              this.patientPosition._long
            );

            return office;
          });
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    refreshGroups() {
      this.groups = [];
      let groupIndexes = [];

      for (let i = 0; i < this.timeslots.length; i++) {
        let timeslot = this.timeslots[i];
        let index = _.findIndex(this.groups, { officeId: timeslot.officeId });

        if (index >= 0) {
          let group = this.groups[index];

          if (group.date >= timeslot.date) {
            group.date = timeslot.date;

            if (group.time >= timeslot.time) {
              group.time = timeslot.time;
            }
          }

          group.timeslots.push(timeslot);

          this.$set(this.groups, index, group);
        } else {
          this.groups.push({
            date: timeslot.date,
            time: timeslot.time,
            distance: timeslot.distance,
            doctorId: timeslot.doctorId,
            doctorAvatar: timeslot.doctorAvatar,
            doctorFirstName: timeslot.doctorFirstName,
            doctorLastName: timeslot.doctorLastName,
            isDoctorRegulated: timeslot.isDoctorRegulated,
            officeCountry: timeslot.officeCountry,
            officeCountryId: timeslot.officeCountryId,
            officeId: timeslot.officeId,
            officeLocality: timeslot.officeLocality,
            officeLocation: timeslot.officeLocation,
            officeName: timeslot.officeName,
            officePhone: timeslot.officePhone,
            officeStreetName: timeslot.officeStreetName,
            officeStreetNumber: timeslot.officeStreetNumber,
            officeZipCode: timeslot.officeZipCode,
            type: timeslot.type,
            timeslots: [timeslot]
          });
        }
      }

      this.loadingTimeslots = false;
      this.fetchNearbyOffices();
    },

    fetchPatientResources() {
      this.hasAppointments = false;
      this.loadingAppointments = true;
      this.hasInvitations = false;
      this.loadingInvitations = true;
      this.hasEmergencies = false;
      this.loadingEmergencies = true;

      appointmentRepository.allForPatient(
        this.userId,
        appointments => {
          if (Object.keys(appointments).length > 0) {
            this.loadingAppointments = false;
            this.hasAppointments = true;
          } else {
            axios
              .get(
                process.env.CLOUD_FUNCTIONS_BASE_URI +
                  "/getPartnerAppointments",
                {
                  params: {
                    userId: this.userId,
                    language: this.shortCode
                  },
                  headers: {
                    "Content-Type": "application/json"
                  }
                }
              )
              .then(response => {
                let now = moment();
                let partnerAppointments = response.data.filter(appointment => {
                  return now.diff(moment(appointment.dateTime)) < 0;
                });

                this.loadingAppointments = false;
                if (partnerAppointments.length > 0) {
                  this.hasAppointments = true;
                }
              })
              .catch(error => {
                this.loadingAppointments = false;
              });
          }
        },
        () => {
          this.loadingAppointments = false;
        }
      );

      appointmentInvitationRepository.allForPatient(
        this.userId,
        invitations => {
          this.loadingInvitations = false;
          if (Object.keys(invitations).length > 0) {
            this.hasInvitations = true;
          }
        },
        () => {
          this.loadingInvitations = false;
        }
      );

      emergencyRepository.allForPatient(
        this.userId,
        emergencies => {
          this.loadingEmergencies = false;
          if (Object.keys(emergencies).length > 0) {
            this.hasEmergencies = true;
          }
        },
        () => {
          this.loadingEmergencies = false;
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Patient/Search.vue